import { NoteBlock } from "./notebook/note/block";

export type PageData = {
  name: string;
};

export interface NotebookPage {
  "page-id": string;
  "folder-id": string;
  "page-data": PageData;
  "app-id": string;
  type: "omega/query-omega/page/Page";
}

export interface NotebookPageMap {
  [pageId: string]: NotebookPage | NotebookPage;
}

export interface PageBlocksMap {
  [pageId: string]: NoteBlock[];
}

export interface NotePageData extends PageData {}

export interface DatabasePageData extends PageData {
  "is-database": "true";
  pages?: NotebookPage[];
}

export interface Notebook {
  pages: NotebookPage[];
}

export interface GetPagesResult {
  pages: (NotebookPage | NotebookPage)[];
}

export function isNotePageData(page: PageData): page is NotePageData {
  return !("is-database" in page);
}

export function isDatabasePageData(
  pageData: PageData,
): pageData is DatabasePageData {
  return "is-database" in pageData;
}

export interface IndentBlockSignal {
  blockIndex: number;
  level: number;
}

export type PagePublished = "true" | "false";

export interface PagePublishedMap {
  [pageId: string]: boolean;
}
